const priceForOne = [
	{
		service1: "Evaluare",
		service2: "",
		price: 210,
	},
	{
		service1: "Sedinta kinetoterapie(50min)",
		service2: "",
		price: 260,
	},
	{
		service1: "Masaj terapeutic(30min)",
		service2: "",
		price: 160,
	},
	{
		service1: "Masaj terapeutic(50min)",
		service2: "",
		price: 230,
	},
	{
		service1: "Sedinta electroterapie (3 proceduri)",
		service2: "",
		price: 115,
	},
	{
		service1: "Terapie Manuala",
		service2: "",
		price: 350,
	},
	{
		service1: "Terapie Tecar(30min)",
		service2: "",
		price: 110,
	},
	{
		service1: "Dryneedeling + Terapie Tecar/Ultrasunet",
		service2: "",
		price: 160,
	},
];

const priceForOneSubscription = [
	{
		service1: "8 sedinte kinetoterapie",
		service2: "",
		price: 1690,
	},
	{
		service1: "10 sedinte kinetoterapie",
		service2: "",
		price: 1745,
	},
	{
		service1: "12 sedinte kinetoterapie",
		service2: "",
		price: 1800,
	},
	{
		service1: "10 sedinte masaj terapeutic(30min)",
		service2: "",
		price: 1430,
	},
	{
		service1: "10 sedinte masaj terapeutic(50min)",
		service2: "",
		price: 1900,
	},
	{
		service1: "10 sedinte electroterapie",
		service2: "",
		price: 1045,
	},
	{
		service1: "10 sedinte tecar",
		service2: "",
		price: 950,
	},
];

const priceForMultipleSubscriptions = [
	{
		service1: "10 sedinte kinetoterapie +",
		service2: "10 sedinte electroterapie + 10 sedinte masaj terapeutic(30min)",
		price: 3500,
	},
	{
		service1: "10 sedinte electroterapie +",
		service2: "10 sedinte masaj terapeutic(30min)",
		price: 2450,
	},
	{
		service1: "10 sedinte kinetoterapie +",
		service2: "10 sedinte masaj terapeutic(30min)",
		price: 2860,
	},
	{
		service1: "10 sedinte kinetoterapie +",
		service2: "10 sedinte masaj terapeutic(50min)",
		price: 3175,
	},
	{
		service1: "12 sedinte kinetoterapie +",
		service2: "10 sedinte masaj terapeutic(30min)",
		price: 2960,
	},
	{
		service1: "12 sedinte kinetoterapie +",
		service2: "10 sedinte masaj terapeutic(50min)",
		price: 3385,
	},
	{
		service1: "10 sedinte kinetoterapie +",
		service2: "10 sedinte electroterapie",
		price: 2645,
	},
	{
		service1: "12 sedinte kinetoterapie +",
		service2: "10 sedinte electroterapie",
		price: 2750,
	},
];

export { priceForOne, priceForOneSubscription, priceForMultipleSubscriptions };
